const state = {
  openedModals: []
}

export default state